import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SetPassenger } from '../../../actions/currentBooking';


class PassengerDropdown extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      Adult:1,
      paxSelectorOpen:false
    }
    this.onPaxSelector = this.onPaxSelector.bind(this);
    this.onPassengerChange = this.onPassengerChange.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }


  componentDidMount(){
    // set initial passenger drop down
    this.props.SetPassenger(this.state);
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){

   try{
    if(e.target.offsetParent.className !== "pax-selector-options" && e.target.offsetParent.className !== "pax-selector-container"){
        if(this.state.paxSelectorOpen) this.setState({paxSelectorOpen: false});
      }
    }catch(e){}
  }

  onPaxSelector(){
    this.setState({paxSelectorOpen: !this.state.paxSelectorOpen});
    document.querySelector('.pax-selector .fa-chevron-down').classList.add('active');
  }



  onPassengerChange(paxType, direction){

    const { Adult } = this.state;
    const { SetPassenger } = this.props;

    if(paxType === 'adult'){
      if(direction === 'down'){
        if(Adult > 0) this.setState({Adult: Adult - 1}, () => SetPassenger(this.state));
      }
      if(direction === 'up'){
         if(Adult < 10) this.setState({Adult: Adult + 1}, () => SetPassenger(this.state));
      }
    }

  }


  renderPaxDropDown(paxType, closeSelector){
    return (
        <div className="pax-selector-options" style={{'display':(paxType) ? 'block' : 'none' }}>
          <div className="row">
            <div className="column small-4">
              <span className="pax-text">Adults</span>
            </div>
            <div className="column small-8 text-right">
              <button type="button" className={`${(this.state.Adult === 0) ? "disabled": ""}`} onClick={e => this.onPassengerChange('adult', 'down')}>
                <span className="down-button">
                  <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{'height':'1em', 'width': '1em', 'display': 'block', 'fill': 'currentcolor' }}>
                    <rect height="2" rx="1" width="12" x="6" y="11"></rect>
                  </svg>
                </span>
              </button>
              <span className="pax-number">{this.state.Adult}</span>
              <button type="button" className={`${(this.state.Adult === 10) ? "disabled": ""}`} onClick={e => this.onPassengerChange('adult', 'up')}>
                <span>
                  <svg viewBox="0 0 25 25" role="img" aria-label="add" focusable="false" style={{'height':'1em', 'width': '1em', 'display': 'block', 'fill': 'currentcolor' }}>
                    <rect height="2" rx="1" width="12" x="6" y="11"></rect>
                    <rect height="12" rx="1" width="2" x="11" y="6"></rect>
                  </svg>
                </span>
              </button>
            </div>
          </div>

          <div className="row">
            <div className="column small-12 text-right">
              <span className="close-text" onClick={closeSelector}>Close</span>
            </div>
          </div>
        </div>
    )
  }


  render(){

    return (
     <div className="row">
        <div className="column small-12">
          <div className="pax-selector-container">
            <div className="pax-selector outline" onClick={this.onPaxSelector}>
              Travellers: {parseInt(this.state.Adult,10)}
              <i className={`fa fa-chevron-down ${this.state.paxSelectorOpen ? 'active' : ''}`} aria-hidden="true"></i>
            </div>
            {this.renderPaxDropDown(this.state.paxSelectorOpen, this.onPaxSelector) }
          </div>
        </div>
      </div>
    )

  }
}


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    SetPassenger
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(PassengerDropdown);



// WEBPACK FOOTER //
// ./src/components/basket/components/passengerdropdown.js